import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

export const Root = styled(Box)({
    '& .head': {
        marginBottom: '17px',
    },
    '& .bgW': {
        width: '285px',
        backgroundColor: '#fff',
    },
    '& .tab': {
        backgroundColor: '#1A9AE7',
        color: '#fff',
    },
    '& .tabSelect': {
        backgroundColor: '#FAFAFA',
        color: '#1A9AE7',
    },
    '& .tableTool': {
        padding: '16px',
        backgroundColor: '#FAFAFA',
        borderBottom: '1px solid #D8D8D8',
        '& .textDateField':{
            margin: '0 10px',
            backgroundColor: '#FFF',
        },
        '& .searchWapper': {
            border: '1px solid #CCCCCC',
            borderRadius: '3px',
            width: '285px',
            height: '38px',
            '& .search': {
                height: '32px',
                color: '#58727C',
                padding: '0 10px',
                backgroundColor: '#fff',
            },
        },
        '& .btn': {
            border: '1px solid #CCCCCC',
        },
    },
    '& .tableWapper': {
        width: '100%',
        overflowX: 'auto',
        '& .table': {
            minWidth: '650px',
        }
    },
    '& .del': {
        color: '#9B9B9B',
        cursor: 'pointer',
    },
    '& .btn': {
        width: '186px',
    },
    '& .m-20': {
        margin: '0 20px',
    },
    '& .wLong': {
        width: '346px !important',
    },
});